import css from './Button.module.scss';
import { Link } from 'react-router-dom';

// size: s, m, l

export default function Button({
  href = '#',
  action,
  variant = 'primary',
  state,
  disabled,
  color = 'blue', // it will be turned to blue-500, etc.
  label,
  iconLeft,
  iconRight,
  iconLeftColor,
  iconLeftBg,
  iconRightColor,
  iconRightBg,
  style,
  size = 'm',
  tooltip,
  // pass disabled/restriced reason here
  type,
  className,
  ...rest
}) {
  let sharedProps,
    finalClass = `sem-h--${variant}-${color} ${css['button']} ${css[size]}`;

  // QUESTION
  if (state === 'loading') finalClass += ' ' + css['loading'];

  if (variant === 'tertiary') finalClass += ' ' + css['tertiary'];

  if (state === 'disabled' || disabled) finalClass += ' ' + css['disabled'];

  // TODO add proccesing state (spinner)

  sharedProps = {
    // ...sharedProps,
    style: style,
    className: finalClass,
    // title: tooltip,
    // TODO do a custom tooltip instead
  };

  const content = (
    <>
      {iconLeft && (
        <i
          className={`${iconLeft} ${iconLeftColor ? `text-color--${iconLeftColor}` : ''} ${
            iconLeftBg ? `${css['has-bg']} bg-color--${iconLeftBg}` : ''
          }`}
        />
      )}
      {label && <span>{label}</span>}
      {iconRight && (
        <i
          className={`${iconRight} ${iconRightColor ? `text-color--${iconRightColor}` : ''} ${
            iconRightBg ? `${css['has-bg']} bg-color--${iconRightBg}` : ''
          }`}
        />
      )}
    </>
  );

  return (
    <>
      {action || type === 'submit' ? (
        <button
          onClick={state != 'disabled' && !disabled ? action : null}
          {...sharedProps}
          {...rest}
          disabled={disabled}
        >
          {content}
        </button>
      ) : /^https?:\/\//.test(href) ? (
        <a href={href} {...sharedProps} {...rest}>
          {content}
        </a>
      ) : (
        <Link to={href} {...sharedProps} {...rest}>
          {content}
        </Link>
      )}
    </>
  );
}
